export default "__VITE_ASSET__Ckpv18DL__"